import { getUserFacingError, parseCreateSessionResponseBody, parseMemberResponseBody } from "./responseParsers/index.js";
export const wrapError = async error => {
  const newError = new Error(error.message);
  newError.stack = error.stack;
  const userFacingError = getUserFacingError(error);
  newError.data = {
    userFacingError
  };

  if (error.response) {
    newError.response = error.response;
    newError.body = error.body;
  }

  return newError;
};
export const wrapMemberResponse = _ref => {
  let {
    response,
    body
  } = _ref;
  const data = parseMemberResponseBody(body);
  return {
    response,
    body,
    data
  };
};
export const wrapCreateSessionResponse = _ref2 => {
  let {
    response,
    body
  } = _ref2;
  const data = parseCreateSessionResponseBody(body);
  return {
    response,
    body,
    data
  };
};